<template>
  <div class="Services_page">
    <titleArea></titleArea>
    <serviceArea></serviceArea>
  </div>
</template>

<script>
import titleArea from "@/components/services/titleArea.vue";
import serviceArea from "@/components/services/serviceArea.vue";

export default {
  name: "Service",
  data() {
    return {};
  },
  components: {
    titleArea,
    serviceArea,
  },
  methods: {},
  mounted() {
    document.body.classList.add("ServicesPage");
  },
  destroyed() {
    document.body.classList.remove("ServicesPage");
  },
};
</script>
<style lang="scss"></style>
